/*
 *
 * DesktopNavBar
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 17-Oct-2024
 */

import DesktopNavBar from './DesktopNavBarContainer'

export default DesktopNavBar
